/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Motivation_Form_Motivations_Motivation_PlaceholderInputs */

const en_motivation_form_motivations_motivation_placeholder = /** @type {(inputs: Motivation_Form_Motivations_Motivation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. 60, max. 2000 characters`)
};

const de_motivation_form_motivations_motivation_placeholder = /** @type {(inputs: Motivation_Form_Motivations_Motivation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mind. 60, max. 2000 Zeichen`)
};

/**
* | output |
* | --- |
* | "Min. 60, max. 2000 characters" |
*
* @param {Motivation_Form_Motivations_Motivation_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const motivation_form_motivations_motivation_placeholder = /** @type {((inputs?: Motivation_Form_Motivations_Motivation_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Motivation_Form_Motivations_Motivation_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_motivation_form_motivations_motivation_placeholder(inputs)
	return en_motivation_form_motivations_motivation_placeholder(inputs)
});